import { render, staticRenderFns } from "./ahSon.vue?vue&type=template&id=041ada28&scoped=true"
import script from "./ahSon.vue?vue&type=script&lang=js"
export * from "./ahSon.vue?vue&type=script&lang=js"
import style0 from "./ahSon.vue?vue&type=style&index=0&id=041ada28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041ada28",
  null
  
)

export default component.exports